/**
*功能: 目录子路由文件
*/

<template>
  <div class="contain">
    <!--<transition name="fade-transform" mode="out-in">-->
      <!--:include="cachedViews"-->
      <keep-alive :exclude="closedViews">
        <router-view :key="key"></router-view>
      </keep-alive>
    <!--</transition>-->
    <!--<div class="page-footer"></div>-->
  </div>
</template>

<script>
import catchs from '@/mixins/catch.mixin';

export default {
  name: 'contain',
  mixins: [catchs],
  data() {
    return {};
  },
  computed: {
    key() {
      return this.$route.fullPath;
    }
  }
};
</script>

<style lang="scss">
.contain {
  flex: 1;
  padding: 10px 10px 0 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  display: flex;
  overflow: hidden;

  .content {
    display: flex;
    flex: 1;
    box-sizing: border-box;
  }

  .page-footer {
    z-index: 999;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    background: #2b2f32;
    color: #fff;
    text-align: center;
  }
}
</style>
